interface IProps {
  text: string
}

export const AccountNoTitle: React.FC<IProps> = ({ text }) => <span className='text-[0.6em] text-text-muted'>{text}</span>
